import { useNode } from '@craftjs/core';
import { Box } from '@mui/material';
import { PropsWithChildren } from 'react';

import { useIsBlockEditorEditMode } from '../BlockEditor.context';
import { createAllowedTypesRule } from '../BlockEditor.utils';

export function BlockEditorRoot({ children }: PropsWithChildren) {
  const {
    connectors: { connect },
  } = useNode();
  const isEditMode = useIsBlockEditorEditMode();

  return (
    <Box
      ref={(ref: HTMLDivElement | null) => {
        if (ref && isEditMode) {
          connect(ref);
        }
      }}
      sx={{
        minHeight: '100%',
        width: '100%',
        position: 'relative',
      }}
    >
      {children}
    </Box>
  );
}

BlockEditorRoot.craft = {
  displayName: 'Block Editor Root',
  props: {},
  rules: {
    canMoveIn: createAllowedTypesRule(),
  },
};
